import React from 'react';
import Helper from './Helper';

class FormWriteReview extends React.Component {
    
    handleShowForm=(flag)=>{
        this.props.handleShowForm(flag);
    }
    handleSubmitFormReview=(e)=>{
        e.preventDefault();
        const data = new FormData(e.target);
        data.set('product_id', this.props.product.info.product_id);
        data.set('alias', this.props.product.info.alias);
        data.set('member_id', this.props.account.id);
        fetch(Helper.getSiteUrl() + '/post/submitReview', {
            method: 'POST',
            body: data,
        }).then(res => res.text()).then(
            (result)=>{
                result = JSON.parse(result);
                result.response === 'success' && 
                window.location.reload();
            }
        );
    }
    render(){
        let {account, product} = this.props,
        {rating} = product;
        if(!account)
        {
            return <div className="alert-component">Vui lòng đăng nhập</div>
        }
        let currentRating = rating ? rating.filter((item)=>item.member_id === account.id):[],
        currentAmount = currentRating.length?parseInt(currentRating[0].number):5,
        ratingControl = [];
        for (let i = 5; i > 0; i--) {
            let checked = i === currentAmount,
            starRating = 
            <div key={i} className="custom-control custom-radio mx-2">
                <input defaultChecked={checked} type="radio" className="custom-control-input" 
                name="rating" id={`rating${i}`} value={i} />
                <label className="custom-control-label d-flex" htmlFor={`rating${i}`}>
                    <span>{i}</span>
                    <img src={Helper.getSiteUrl() + "/resource/images/ico_star_yellow.svg"}  className="img-fluid"/>
                </label>
            </div>
            ratingControl.push(starRating);
        }
        let inputName = account.review_name ? 
        <select className="form-control" name="input_name" defaultValue={account.review_name}>
            <option value={account.review_name}>{account.review_name}</option>
            <option value={account.name}>{account.name}</option>
        </select>:
        <input className="form-control" required name="input_name" 
        defaultValue={account.name} placeholder="Tên hiển thị" />
        return(
            <div className="form-review-popup w-100">
                <div className="form-popup">
                    <span className="btn-close" onClick={()=>this.handleShowForm(false)}><i className="fa fa-times" /></span>
                    <h3 className="popup-title">Nhận xét của bạn</h3>
                    <hr className="my-1"/>
                    <form method="post" className="p-3" onSubmit={(e)=>this.handleSubmitFormReview(e)}>
                        <div className="form-group">
                            <label>Bạn đánh giá sản phẩm này</label>
                            <div className="d-flex justify-content-center">
                            {ratingControl}
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><i className="fas fa-user"></i></span>
                                </div>
                                {inputName}
                            </div>
                            
                        </div>
                        <div className="form-group">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><i className="fas fa-pencil-alt" /></span>
                                </div>
                                <input required className="form-control" name="title" placeholder="Tiêu đề" />
                            </div>
                        </div>
                        <div className="form-group">
                            <textarea rows="5" required className="form-control" name="content" placeholder="Nội dung"></textarea>
                        </div>
                        <div className="form-group">
                            <button type="button" onClick={()=>this.handleShowForm(false)} 
                            className="btn btn-default btn_review mr-2"><i className="fa fa-times"/> Đóng</button>
                            <button className="btn btn-success btn_review">Gửi review</button>
                        </div>
                    </form>
                
                </div>
            </div>
        )
    }
}
export default FormWriteReview;